"use strict";

module.exports = {
  template: require('./emil-header.component.html')
};



// WEBPACK FOOTER //
// ./src/main/webapp-files/modules/app/components/header/emil-header.component.js